var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"supplements"}},[_c('Datatable',{ref:"datatable",attrs:{"entity":"tax","globalActions":[{text: 'tax.new', method: _vm.onCreate}],"rowActions":[{text: 'datatable.edit', method: _vm.onRowEdit}, {text: 'datatable.delete', method: _vm.onRowDelete}],"onRowClick":_vm.onRowEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }